/** Le module Node `path`, réduit à ce que server.js utilise. Tout vit sous /scanyt. */
function normaliser(chemin) {
  const sortie = [];
  for (const morceau of chemin.split('/')) {
    if (!morceau || morceau === '.') continue;
    if (morceau === '..') sortie.pop();
    else sortie.push(morceau);
  }
  return `/${sortie.join('/')}`;
}

export const join = (...morceaux) => normaliser(morceaux.join('/'));
export const resolve = join;
export const dirname = (chemin) => normaliser(chemin).replace(/\/[^/]*$/, '') || '/';
export const basename = (chemin) => normaliser(chemin).split('/').pop();
